"use stric";

const TypesReport = {
  table: {
    type: 0,
  },
  chart: {
    type: 1,
  },
  consolidated: {
    type: 2,
  },
  tableByDay: {
    type: 3,
  },
  geoZoneByDay: {
    type: 4,
  },
};

export default TypesReport;
